import { createSlice } from '@reduxjs/toolkit';

interface TableRowColors {
  [view: string]:
    | Record<string, string>
    | Record<string, Record<string, string>>;
}
interface SuperAdminState {
  headingName: string;
  loading: boolean;
  environment: string;
  superAdminStatisticCount: {
    activeClientIdsCount: number;
    activeAdminsCount: number;
    newRequestsCount: number;
  };
  isSettingsModalOpen: boolean;
  merchantSelected: { [key: string]: any } | undefined;
  merchantList: {};
  tableRowColors: TableRowColors;
}

const initialState: SuperAdminState = {
  headingName: 'Dashboard',
  loading: false,
  environment: 'Sandbox',
  superAdminStatisticCount: {
    activeClientIdsCount: 0,
    activeAdminsCount: 0,
    newRequestsCount: 0,
  },
  isSettingsModalOpen: false,
  merchantSelected: undefined,
  merchantList: {},
  tableRowColors: {
    activeMerchants: {},
    manageRequests: {},
    manageAdmins: {
      manageStatus: {},
      manageInvitations: {},
    },
  } as TableRowColors,
};

const superAdminSlice = createSlice({
  name: 'superAdmin',
  initialState,
  reducers: {
    setheadingName(state, { payload }) {
      state.headingName = payload;
    },
    setSuperAdminLoading(state, { payload }) {
      state.loading = payload;
    },
    setSuperAdminStatisticCount(state, { payload }) {
      state.superAdminStatisticCount = payload;
    },
    setEnvironment(state, { payload }) {
      state.environment = payload;
    },
    openSettingsModal: (state, { payload }) => {
      state.isSettingsModalOpen = true;
      state.merchantSelected = payload;
    },
    closeSettingsModal: (state) => {
      state.isSettingsModalOpen = false;
    },
    setMerchantList: (state, { payload }) => {
      state.merchantList = payload;
    },
    setMerchantSelected: (state, { payload }) => {
      state.merchantSelected = payload;
    },
    setRowColor: (state, { payload }) => {
      const { view, rowId, color } = payload;
      const viewColors = state.tableRowColors[view] as Record<string, string>;
      if (viewColors) {
        viewColors[rowId] = color;
      }
    },
    setRowColorsForView: (state, { payload }) => {
      const { view, subView, colors } = payload;

      if (!state.tableRowColors[view]) {
        state.tableRowColors[view] = {};
      }

      if (subView && !state.tableRowColors[view][subView]) {
        state.tableRowColors[view][subView] = {};
      }

      if (subView) {
        if (!state.tableRowColors[view][subView]) {
          state.tableRowColors[view][subView] = {};
        }
        state.tableRowColors[view][subView] = {
          ...(state.tableRowColors[view][subView] as Record<string, string>),
          ...colors,
        };
      } else {
        state.tableRowColors[view] = {
          ...(state.tableRowColors[view] as Record<string, string>),
          ...colors,
        };
      }
    },
  },
});

const { actions } = superAdminSlice;
export const superAdminSliceAction = actions;
export default superAdminSlice.reducer;
